import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { Certifications } from "./components/site/Certifications";
import { Services } from "./components/site/Services";
import { About } from "./components/site/About";
import { WhyChooseUs } from "./components/site/WhyChooseUs";
import { Location } from "./components/site/Location";
import { FAQ } from "./components/site/FAQ";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { QuoteDialog } from "./components/site/QuoteDialog";
import { StickyMobileCTA } from "./components/site/StickyMobileCTA";
import { ServiceDetailPage } from "./components/site/ServiceDetailPage";
import { MachineryPage } from "./components/site/MachineryPage";
import { MachineryTeaser } from "./components/site/MachineryTeaser";

const LandingPage = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const openQuote = () => setQuoteOpen(true);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 80);
    }
  }, [location]);

  return (
    <div className="App bg-[#FAFAFA] text-[#1A1A1A] min-h-screen font-body pb-16 lg:pb-0 overflow-x-hidden">
      <Header onQuoteClick={openQuote} />
      <main>
        <Hero onQuoteClick={openQuote} />
        <Certifications />
        <Services onQuoteClick={openQuote} />
        <About />
        <WhyChooseUs />
        <MachineryTeaser />
        <Location />
        <FAQ />
        <Contact onQuoteClick={openQuote} />
      </main>
      <Footer />
      <StickyMobileCTA />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/machinery" element={<MachineryPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
